import { render, staticRenderFns } from "./LockForm.vue?vue&type=template&id=551630b0&scoped=true"
import script from "./LockForm.vue?vue&type=script&lang=js"
export * from "./LockForm.vue?vue&type=script&lang=js"
import style0 from "./LockForm.vue?vue&type=style&index=0&id=551630b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551630b0",
  null
  
)

export default component.exports